import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface EnrollmentGrowth {
  month: string;
  year: number;
  added: number;
  dropped: number;
}

export interface GetEnrollmentGrowthParams {
  sessionId: string;
  startDate: string; // yyyy-mm-dd
  endDate: string; // yyyy-mm-dd
}

export const getEnrollmentGrowthAPI = async ({
  sessionId,
  startDate,
  endDate,
}: GetEnrollmentGrowthParams) => {
  const response = await baseAPI.get<Array<EnrollmentGrowth>>(
    '/dashboard/metrics/enrollment-growth',
    {
      params: {
        sessionId,
        startDate,
        endDate,
      },
    },
  );
  return response.data;
};

export const useGetEnrollmentGrowth = (params: GetEnrollmentGrowthParams) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.ENROLLMENT_GROWTH,
      params.sessionId,
      params.startDate,
      params.endDate,
    ],
    queryFn: () => getEnrollmentGrowthAPI(params),
    enabled: !!params.sessionId && !!params.startDate && !!params.endDate,
  });
};
